export type Option = {
    value: string;
    label: string;
};

export const timeZones: Option[] = [
    { value: 'America/Mexico_City', label: 'America/Mexico_City (GMT-5:00)' },
    { value: 'America/Bogota', label: 'America/Bogota (GMT-5:00)' },
    { value: 'America/Lima', label: 'America/Lima (GMT-5:00)' },
    { value: 'America/Santiago', label: 'America/Santiago (GMT-4:00)' },
    { value: 'America/Buenos_Aires', label: 'America/Buenos_Aires (GMT-3:00)' },
    { value: 'America/Montevideo', label: 'America/Montevideo (GMT-3:00)' },
    { value: 'America/Sao_Paulo', label: 'America/Sao_Paulo (GMT-3:00)' },
    { value: 'America/Caracas', label: 'America/Caracas (GMT-4:00)' },
    { value: 'America/Costa_Rica', label: 'America/Costa_Rica (GMT-6:00)' },
    { value: 'America/Guatemala', label: 'America/Guatemala (GMT-6:00)' },
    { value: 'America/La_Paz', label: 'America/La_Paz (GMT-4:00)' },
    { value: 'America/Guayaquil', label: 'America/Guayaquil (GMT-5:00)' },
    { value: 'Europe/Madrid', label: 'Europe/Madrid (GMT+2:00)' },
];
